export const weeklyBundle = {
  title: { ko: "주간 누수 추이", en: "Weekly Leakage Trends", es: "Tendencias semanales de fugas" },
  legends: [
    { ko: "일일누수량", en: "Daily Leakage Vol.", es: "Volumen diario de fugas" },
    { ko: "누수 수용가", en: "Leaking Households", es: "Hogares con fugas" }
  ],
  labels: [
    { ko: "누수량 (m³)", en: "Leakage Volume (m³)", es: "Volumen de fuga (m³)" },
    { ko: "누수 수용가 수", en: "Leaking Households", es: "Hogares con fugas" }
  ],
  unit: {
    household: { ko: "가구", en: "HH", es: "Hogares" }
  }
}
